import { ReactComponent as StarIcon } from "../assets/icons/staricon.svg";

interface IFavoriteButtonProps{
  onFavoriteClick: (event: React.MouseEvent<SVGElement, MouseEvent>) => void;
  fill: string;
}

const FavoriteButton:React.FC<IFavoriteButtonProps> = (props: IFavoriteButtonProps) => {
  const { onFavoriteClick, fill } = props;

  const style = '.favoriteicon:hover { fill: yellow !important }'
  
  return (
    <>
      <style>{style}</style>
      <StarIcon
        id={'favorite-course'}  
        className="favoriteicon"
        onClick={(event: React.MouseEvent<SVGElement, MouseEvent>) => { event.preventDefault(); onFavoriteClick(event)}}
        style={{ 
          width: '20px', 
          height: '20px', 
          margin: '0px', 
          fill: fill
        }}/>
    </>
  )
}

export default FavoriteButton;